import React from 'react';
import formattedAmount from '../../seller/components/utils';
import './style/commandDetails.css';


export default function CommandDetails({group=null, rates, currency}) {
    return (
        <div className='wz-command-details-container'>
            {group && <div className='wz-command-details-group-title'>{group.name}</div>}
            {rates.map((rate) => {
                return (
                    <div className='wz-command-details-rate'>
                        <div className='wz-command-details-rate-and-quantity'>
                            <div className='wz-command-details-quantity'>x{rate.quantity}</div>
                            <div>{rate.name}</div>
                        </div>
                        <div>{formattedAmount(rate.price * rate.quantity, currency)}</div>
                    </div>
                )
            })}
        </div>
    )
}